import type { IndustryOnePagerConfig, Section } from '../copy';
import { SHARED_HERO } from '../copy';

const SECTIONS: Section[] = [
  {
    heading: 'Model your site in 3D',
    body: [
      {
        spans: [
          { text: 'unimoBuild', strong: true },
          {
            text: ' lets you model a site from scratch in minutes. No modelling skills required, just talk to it.',
          },
        ],
      },
      {
        spans: [
          {
            text: 'It can import from your existing designs, converting PDFs, screenshots or photos, and it supports IFC imports from Navisworks or Revit.',
          },
        ],
      },
      {
        spans: [
          {
            text: 'Either way you get an accurate, living 3D model that makes digital rehearsal, temporary works design and delivery planning easy.',
          },
        ],
      },
    ],
  },
  {
    heading: 'Watch it live',
    body: [
      {
        spans: [
          { text: 'Forget juggling lots of other apps. The ' },
          { text: 'unimoLive', strong: true },
          {
            text: ' hub speaks to every kind of IoT sensor: existing ones, new ones, any make. It lays their readings over a map of your site or your ',
          },
          { text: 'unimoBuild', strong: true },
          { text: ' twin. One screen, in real time, with no fuss.' },
        ],
      },
      {
        spans: [
          {
            text: 'Monitor power usage, site noise levels, environmental factors, concrete pours… anything you care to track.',
          },
        ],
      },
      {
        spans: [
          {
            text: 'We know everything about your site’s weather, using all available weather models to aid short-term planning.',
          },
        ],
      },
    ],
  },
  {
    heading: 'Report on anything, anytime',
    body: [
      {
        spans: [
          { text: 'No IT tickets. Just accurate dashboards, onsite, in seconds. ' },
          { text: 'unimoReport', strong: true },
          { text: ' turns the stream of data ' },
          { text: 'unimoLive', strong: true },
          {
            text: ' captures into clear answers. Plus you can hand it your method plans and planning documents so it understands the context behind the numbers.',
          },
        ],
      },
    ],
  },
];

export const constructionConfig: IndustryOnePagerConfig = {
  slug: 'construction',
  route: '/construction/one-pager',
  meta: {
    title: 'unimo: Model, watch, and report on your site.',
    description:
      'Model, watch, and report on your site. No data engineers, no analysts. Just ask.',
  },
  hero: SHARED_HERO,
  sections: SECTIONS,
  illustration: { src: '/assets/one-pager/construction/illustration.svg' },
  pdfDownloadPath: '/downloads/unimo-construction-one-pager.pdf',
};
